<div class="modal-header">
  <div class="col-lg-6">
    <div class="text-header inc-f">
      <span class="fa fa-list"></span> Impact Assessment Workflow 
    </div>
  </div>
  <div class="col-lg-6 f-15">
    <button class="fa fa-times pull-right" [mat-dialog-close]="" style="cursor: pointer;background: none;border:none"
      aria-hidden="true"></button>
    <a href="/impact-assessment/details/impact/{{templateNo}}/{{id}}" target="_blank">
      <span class="fa fa-external-link pull-right external" title="Open in New Window"></span>
    </a>
  </div>
</div>
<div class="modal-body" *ngIf="!isForAssessedAtChangeViewer && templateNo != 4 && templateNo != 5 && templateNo!=6">
  <app-impact-assessment-info [impactAssessmentId]="id" [filterType]="assessmentType"></app-impact-assessment-info>
</div>
<div class="modal-body" *ngIf="!isForAssessedAtChangeViewer && templateNo == 4">
  <app-impact-assessment-template4 [impactAssessmentId]="id" [filterType]="assessmentType"></app-impact-assessment-template4>
</div>
<!--For Impact Assessment Template 5-->
<div class="modal-body" *ngIf="!isForAssessedAtChangeViewer && templateNo == 5">
  <app-impact-assessment-template5 [impactAssessmentId]="id" [filterType]="assessmentType"></app-impact-assessment-template5>
</div>
<div class="modal-body" *ngIf="!isForAssessedAtChangeViewer && templateNo == 6">
  <app-impact-assessment-template6 [impactAssessmentId]="id" [filterType]="assessmentType"></app-impact-assessment-template6>
</div>

